import React, { useState } from "react";
import { Box, Button, Stack } from "@mui/material";
import { FileWithPreview } from "../types";
import { ChunkedFileWithPreview } from "../types/chunkedUploadTypes";
import { ExpandMore, ExpandLess } from "@mui/icons-material";
import ChatAttachmentItem from "./ChatAttachmentItem";

type ChatAttachmentsProps = {
  files: (FileWithPreview | ChunkedFileWithPreview)[];
  onRemove?: (index: number) => void;
  isEditable?: boolean;
  autoCollapseThreshold?: number;
};

const ChatAttachments: React.FC<ChatAttachmentsProps> = ({
  files,
  onRemove,
  isEditable = false,
}) => {
  const [isExpanded, setIsExpanded] = useState(true);

  if (!files || files.length === 0) return null;

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  const shouldShowExpandButton = files.length;

  return (
    <Box
      sx={{ mx: 0.5, mt: 0.5, position: "relative" }}
      id="chat-attachments-box"
      data-testid="aa-msg-file-list"
    >
      {shouldShowExpandButton && (
        <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 1 }}>
          <Button
            variant="outlined"
            size="small"
            onClick={toggleExpanded}
            data-attr="assistant:btn:toggle-message-attachments"
            startIcon={isExpanded ? <ExpandLess /> : <ExpandMore />}
            sx={{
              fontSize: "0.75rem",
              textTransform: "none",
              borderColor: "divider",
              bgcolor: "background.paper",
              color: "text.primary",
              "&:hover": {
                borderColor: "divider",
                backgroundColor: "rgba(16, 139, 219, 0.04)",
              },
            }}
          >
            {isExpanded ? "Collapse" : `Show all ${files.length} files`}
          </Button>
        </Box>
      )}

      {isExpanded && (
        <Stack direction="row" gap={1} flexWrap="wrap">
          {files.map((file, index) => (
            <ChatAttachmentItem
              key={`${file.name}-${index}`}
              file={file}
              index={index}
              onRemove={onRemove}
              isEditable={isEditable}
            />
          ))}
        </Stack>
      )}
    </Box>
  );
};

export default ChatAttachments;
